import {IconButton, IconButtonTypeMap} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import classNames from 'classnames';
import {Link, LinkProps} from 'react-router-dom';

import {moreArrowLinkStyles} from 'src/Components/Common/Links/moreArrowLinkStyles';

const MoreArrowLink = (props: IMoreArrowLinkProps) => {
	const classes = classNames(props.classes.button, {
		'-is-small': props.size === 'small',
	});

	return (
		<span className={classNames([props.classes.root, props.className])}>
			{/* @ts-ignore @TODO fix on migration to next.js IconButton does not have the component property */}
			<IconButton size={props.size} className={classes} component={Link} to={props.to} disableRipple>
				<ArrowForwardIcon fontSize={props.size === 'small' ? 'small' : 'inherit'} />
			</IconButton>
		</span>
	);
};

export interface IMoreArrowLinkProps extends WithStyles {
	className?: string;
	to?: LinkProps['to'] | string;
	size?: IconButtonTypeMap['props']['size'];
}

export default withStyles(moreArrowLinkStyles)(MoreArrowLink);
